var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCareer01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.3171,
    y: 4.02295,
    width: 6.5,
    height: 14.5,
    fill: "#232158"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2331 30.5229H8.23309C7.70282 30.5224 7.19442 30.3115 6.81946 29.9366C6.44451 29.5616 6.23362 29.0532 6.23309 28.5229V4.52295C6.23362 3.99268 6.44451 3.48428 6.81946 3.10932C7.19442 2.73436 7.70282 2.52348 8.23309 2.52295H24.2331C24.7634 2.52348 25.2718 2.73436 25.6467 3.10932C26.0217 3.48428 26.2326 3.99268 26.2331 4.52295V21.1409L21.2331 18.6409L16.2331 21.1409V4.52295H8.23309V28.5229H24.2331V24.5229H26.2331V28.5229C26.2323 29.0531 26.0213 29.5614 25.6464 29.9363C25.2715 30.3112 24.7633 30.5222 24.2331 30.5229ZM21.2331 16.4049L24.2331 17.9049V4.52295H18.2331V17.9049L21.2331 16.4049Z",
    fill: "#7B1FFE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer01);
export default __webpack_public_path__ + "static/media/career-01.16d18cbf6ce4e67af0fe01829b84cc92.svg";
export { ForwardRef as ReactComponent };